import {Routes} from '@angular/router';
import {AnalyticsSubsection} from './enums/analytics-subsection';
import {RoutingEnum} from './enums/routing.enum';
import {hashPagesGuard} from './guards/hash-pages/hash-pages.guard';
import {stepGuard} from './guards/step.guard';
import {RouterDataResolver, RouterThankYouFlowResolver} from './utils/router-data.resolver';

export const routes: Routes = [
  {
    path: RoutingEnum.homepage,
    loadComponent: () =>
      import('./routes/homepage/homepage.component').then((m) => m.HomepageComponent),
    data: {
      step: '-1',
      type: 'homepage',
      isBigFooter: false,
      pageName: 'homepage',
      subSection: AnalyticsSubsection.HOME_PAGE,
      analyticsFunnel: 'fastquote',
    },
    title: 'Fastquote - Home',

    canActivate: [hashPagesGuard],
  },
  {
    path: RoutingEnum.Energia,
    loadComponent: () =>
      import('./routes/homepage/homepage.component').then((m) => m.HomepageComponent),
    data: {
      step: '-1',
      type: 'energia',
      isBigFooter: false,
      pageName: 'homepage_lithium',
      subSection: AnalyticsSubsection.HOME_PAGE,
      analyticsFunnel: 'fastquote',
    },
    title: 'Fastquote - Energia',
  },
  {
    path: RoutingEnum.AllianzPay,
    loadComponent: () =>
      import('./routes/allianz-pay/allianz-pay.component').then((m) => m.AllianzPayComponent),
    data: {
      step: '-1',
      type: 'allianzPay',
      isBigFooter: false,
      pageName: 'allianzpay',
      subSection: AnalyticsSubsection.RECUPERO_PREVENTIVO_ALLIANZ_PAY,
      AnalyticsStep: 'codice_allianz_pay',
      analyticsFunnel: 'allianz_pay',
    },
    title: 'Fastquote - Home',
    canActivate: [hashPagesGuard],
  },
  {
    path: RoutingEnum.Step1,
    loadComponent: () =>
      import('./routes/Preventivatore/step-one/step-one.component').then((m) => m.StepOneComponent),
    data: {
      step: '0',
      isBigFooter: true,
      pageName: RoutingEnum.Step1,
      subSection: AnalyticsSubsection.QUOTAZIONE,
      AnalyticsStep: 'step1',
    },
    resolve: {data: RouterDataResolver},
    title: 'Fastquote - 1/3 - Personalizza la tua polizza',
    canActivate: [stepGuard],
  },
  {
    path: RoutingEnum.Confirm,
    loadComponent: () =>
      import('./routes/Preventivatore/step-two/step-two.component').then((m) => m.StepTwoComponent),
    data: {
      step: '1',
      isBigFooter: true,
      pageName: RoutingEnum.Confirm,
      subSection: AnalyticsSubsection.CONFERMA_DATI,
      AnalyticsStep: 'step2',
    },
    resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
    title: 'Fastquote - 2/3 - Conferma dati',
    canActivate: [stepGuard],
  },
  {
    path: RoutingEnum.Summary,
    loadComponent: () =>
      import('./routes/Preventivatore/resume-step/resume-step.component').then(
        (m) => m.ResumeStepComponent,
      ),
    data: {
      step: '2',
      isBigFooter: true,
      pageName: RoutingEnum.Summary,
      subSection: AnalyticsSubsection.SALVA_ACQUISTA,
      AnalyticsStep: 'step3',
    },
    resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
    title: 'Fastquote - 3/3 - Riepilogo dati',
    canActivate: [stepGuard],
  },
  // {
  //   path: RoutingEnum.Contacts,
  //   loadComponent: () =>
  //     import('./routes/Preventivatore/step-contacts/step-contacts.component').then(
  //       (m) => m.StepContactsComponent,
  //     ),
  //   data: {step: '3', isBigFooter: true},
  //   resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
  //   title: 'Fastquote - Conferma',
  //   canActivate: [stepGuard],
  // },
  {
    path: RoutingEnum.ConfirmBuy,
    loadComponent: () =>
      import('./routes/Preventivatore/step-contacts/step-contacts.component').then(
        (m) => m.StepContactsComponent,
      ),
    data: {
      step: '3',
      isBigFooter: true,
      pageName: 'conferma_acquisto',
      subSection: AnalyticsSubsection.SALVA_ACQUISTA,
      AnalyticsStep: 'step4a',
    },
    resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
    title: 'Fastquote - Conferma',
    canActivate: [stepGuard],
  },
  {
    path: RoutingEnum.ConfirmQuotation,
    loadComponent: () =>
      import('./routes/Preventivatore/step-contacts/step-contacts.component').then(
        (m) => m.StepContactsComponent,
      ),
    data: {
      step: '3',
      isBigFooter: true,
      pageName: 'conferma_quotazione',
      subSection: AnalyticsSubsection.CONFERMA_DATI,
      AnalyticsStep: 'step4a',
    },
    resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
    title: 'Fastquote - Conferma',
    canActivate: [stepGuard],
  },
  {
    path: RoutingEnum.AllianzPaySummary,
    loadComponent: () =>
      import('./routes/Preventivatore/allianz-pay-summary/allianz-pay-summary.component').then(
        (m) => m.AllianzPaySummaryComponent,
      ),
    data: {
      step: '3',
      isBigFooter: true,
      type: 'allianzPay',
      pageName: 'allianzPay_riepilogo',
      subSection: AnalyticsSubsection.RIEPILOGO_ALLIANZ_PAY,
    },
    resolve: {data: RouterDataResolver},
    title: 'Fastquote - Riepilogo dati',
    canActivate: [stepGuard],
  },
  {
    path: RoutingEnum.AlreadyInsured,
    loadComponent: () =>
      import('./routes/service/already-insured/already-insured.component').then(
        (m) => m.AlreadyInsuredComponent,
      ),
    data: {
      isBigFooter: false,
      pageName: 'gia_assicurato',
      subSection: AnalyticsSubsection.ERROR_PAGE,
    },
    title: 'Fastquote - Già assicurata',
  },
  {
    path: RoutingEnum.QuotationError,
    loadComponent: () =>
      import('./routes/service/quotation-error/quotation-error.component').then(
        (m) => m.QuotationErrorComponent,
      ),
    data: {
      isBigFooter: false,
      pageName: 'errore_quotazione',
      subSection: AnalyticsSubsection.ERROR_PAGE,
    },
    title: 'Fastquote - Errore quotazione',
  },
  {
    path: RoutingEnum.GenericError,
    loadComponent: () =>
      import('./routes/service/generic-error/generic-error.component').then(
        (m) => m.GenericErrorComponent,
      ),
    data: {
      isBigFooter: false,
      pageName: 'errore_generico',
      subSection: AnalyticsSubsection.ERROR_PAGE,
    },
    title: 'Fastquote - Errore',
  },
  {
    path: RoutingEnum.AllianzPayGenericError,
    loadComponent: () =>
      import('./routes/service/generic-error/generic-error.component').then(
        (m) => m.GenericErrorComponent,
      ),
    data: {
      isBigFooter: false,
      type: 'allianzPay',
      pageName: 'allianzPay_errore_generico',
      subSection: AnalyticsSubsection.ERROR_PAGE,
    },
    title: 'Fastquote - Errore',
  },
  {
    path: RoutingEnum.AllianzPayInvalidCodeError,
    loadComponent: () =>
      import('./routes/service/generic-error/generic-error.component').then(
        (m) => m.GenericErrorComponent,
      ),
    data: {
      translationPath: 'ALLIANZ_PAY_INVALID_CODE',
      isBigFooter: false,
      type: 'allianzPay',
      pageName: 'allianzPay_codice_scaduto',
      subSection: AnalyticsSubsection.ERROR_PAGE,
    },
    title: 'Fastquote - Errore',
  },
  {
    path: RoutingEnum.PaymentError,
    loadComponent: () =>
      import('./routes/thank-you-page/thank-you-page.component').then(
        (m) => m.ThankYouPageComponent,
      ),
    data: {
      isBigFooter: false,
      isPaymentOk: false,
      pageName: 'errore_pagamento',
      subSection: AnalyticsSubsection.ERROR_PAGE,
    },
    resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
    title: 'Fastquote - Errore pagamento',
  },
  {
    path: RoutingEnum.AllianzPayPaymentError,
    loadComponent: () =>
      import('./routes/thank-you-page/thank-you-page.component').then(
        (m) => m.ThankYouPageComponent,
      ),
    data: {
      isBigFooter: false,
      isPaymentOk: false,
      type: 'allianzPay',
      pageName: 'allianzPay_errore_pagamento',
      subSection: AnalyticsSubsection.ERROR_PAGE,
    },
    resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
    title: 'Fastquote - Errore pagamento',
  },
  {
    path: RoutingEnum.AllianzPayPaymentOk,
    loadComponent: () =>
      import('./routes/payment-check/payment-check.component').then((m) => m.PaymentCheckComponent),
    data: {
      step: '9',
      isBigFooter: true,
      isPaymentOk: true,
      type: 'allianzPay',
      forceRedirectToHome: true,
      pageName: 'allianzPay_polizza_acquistata',
      subSection: AnalyticsSubsection.PURCHASE_ALLIANZ_PAY,
      AnalyticsStep: 'thk_page',
    },
    title: 'Fastquote - Grazie',
    canActivate: [],
  },
  {
    path: RoutingEnum.Disservice,
    loadComponent: () =>
      import('../libs/service-unavailable-page/pages/error/error.component').then(
        (m) => m.ErrorComponent,
      ),
    data: {
      isBigFooter: false,
      showInformationFooter: false,
      pageName: 'disservizio',
      subSection: AnalyticsSubsection.DISSERVIZIO,
    },
    title: 'Fastquote - Disservizio',
  },
  {path: RoutingEnum.ecommerce, redirectTo: RoutingEnum.homepage, pathMatch: 'full'},

  {
    path: RoutingEnum.Thankyou,
    loadComponent: () =>
      import('./routes/thank-you-page/thank-you-page.component').then(
        (m) => m.ThankYouPageComponent,
      ),
    data: {
      step: '10',
      isBigFooter: true,
      forceRedirectToHome: true,
      pageName: 'grazie',
      subSection: AnalyticsSubsection.THANKYOU_PAGE,
      AnalyticsStep: 'salvataggio_completato',
    },
    resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
    title: 'Fastquote - Grazie',
    canActivate: [stepGuard],
  },
  {
    path: RoutingEnum.ThankyouQuotation,
    loadComponent: () =>
      import('./routes/thank-you-page/thank-you-page.component').then(
        (m) => m.ThankYouPageComponent,
      ),
    data: {
      step: '10',
      isBigFooter: true,
      forceRedirectToHome: true,
      pageName: 'salva_quotazione',
      subSection: AnalyticsSubsection.THANKYOU_PAGE,
      AnalyticsStep: 'salvataggio_completato',
    },
    resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
    title: 'Fastquote - Salvataggio Quotazione',
    canActivate: [stepGuard],
  },
  {
    path: RoutingEnum.ThankyouEstimation,
    loadComponent: () =>
      import('./routes/thank-you-page/thank-you-page.component').then(
        (m) => m.ThankYouPageComponent,
      ),
    data: {
      step: '10',
      isBigFooter: true,
      forceRedirectToHome: true,
      pageName: 'salva_preventivo',
      subSection: AnalyticsSubsection.THANKYOU_PAGE,
      AnalyticsStep: 'thk_page',
    },
    resolve: {data: RouterDataResolver, flow: RouterThankYouFlowResolver},
    title: 'Fastquote - Salva Preventivo',
    canActivate: [stepGuard],
  },

  {
    path: RoutingEnum.Payment,
    loadComponent: () =>
      import('./routes/payment-check/payment-check.component').then((m) => m.PaymentCheckComponent),
    data: {
      step: '9',
      isBigFooter: true,
      isPaymentOk: true,
      forceRedirectToHome: true,
      pageName: 'polizza_acquistata',
      subSection: AnalyticsSubsection.THANKYOU_PAGE,
      AnalyticsStep: 'thk_page',
    },
    title: 'Fastquote - Polizza acquistata',
    canActivate: [],
  },
  {
    path: RoutingEnum.NotFound,
    loadComponent: () =>
      import('./routes/service/not-found/not-found.component').then((m) => m.NotFoundComponent),
    data: {
      pageName: 'pagina_non_trovata',
      subSection: AnalyticsSubsection.NOT_FOUND,
    },
    title: 'Fastquote - Pagina non trovata',
    canActivate: [hashPagesGuard],
  },
];
